<template src="./template.html"></template>

<script>

import NavLink from '@/components/modules/DynamicLink/NavLink'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DynamicLink',
  components: {
    NavLink,
  },
  props: {
    'links': {
      type: String,
      required: true,
    },
    'navbarType': String,
    'urlLogin': String,
    'urlLogout': String,
    'urlWishlist': String,
    'urlBonusProgram': String,
    'urlProfile': String,
  },
  data() {
    return {
      dynamicLinks: [
        {
          id: 'wishlist',
          route: this.urlWishlist,
          label: 'top_nav.wishlist',
          is_protected: true,
          is_feature: true,
        },
        {
          id: 'profile',
          route: this.urlProfile,
          label: 'top_nav.account',
          is_protected: true,
          is_feature: false,
        },
        {
          id: 'bonus_program',
          route: this.urlBonusProgram,
          label: null,
          is_protected: true,
          is_feature: true,
          classes: [ 'bonus_program_coin' ],
        },
        {
          id: 'auth',
          route: null,
          label: null,
          is_protected: false,
          is_feature: false,
        },
      ],
    }
  },
  computed: {
    ...mapState('auth', [
      'auth_status',
      'pendingAuth',
      'isInit',
    ]),
    ...mapState('translations', [ 'pendingTranslations' ]),
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),

    navLinks() {
      const navItems = this.links ? JSON.parse(this.links) : []
      const { isAuthenticated } = this.auth_status

      return this.dynamicLinks.filter(link => {
        if (!navItems.some(item => item === link.id) || (link.id === 'bonus_program' && !this.isBonusProgramActive)) return false

        if (!link.is_protected) return true

        return isAuthenticated && (!link.is_feature || this.hasFeature(link.id))
      }).map(link => {

        if (link.id === 'auth')
          return {
            ...link,
            route: !isAuthenticated ? this.urlLogin : this.urlLogout,
            label: !isAuthenticated ? 'my_account.login.log_in' : 'my_account.logout',
          }

        if (link.id === 'bonus_program' && this.navbarType === 'top')
          return { ...link, label: this.settings?.current_user?.bonus_points.toString() }

        return link
      })
    },
    isBonusProgramActive() {
      return this.settings?.current_user?.bonus_program_member
    },
    pending() {
      return Boolean(this.isInit || this.pendingTranslations || this.pendingAuth || this.pendingSettings)
    },
  },

  created() {
    this.getAuthStatus()
    this.getSettings()
  },

  methods: {
    ...mapActions('auth', ['getAuthStatus']),
    ...mapActions('settings', ['getSettings']),

    /**
     *
     * @param feature
     * @returns {*}
     */
    hasFeature(feature) {
      const { active_features } = this.settings
      return active_features ? active_features[feature] : true
    },

    /**
     *
     * @param link
     * @returns {*}
     */
    getLabel(link) {
      // if (link === 'auth')
      //   return this.authLabel
      // else if (link === 'bonus_program') {
      //   return this.settings?.current_user?.bonus_points
      // }
      return this.dynamicLinks[link].label
    },
  },

}
</script>
